import { render } from "./IllustrationThree.vue?vue&type=template&id=472a5cd0&scoped=true"
import script from "./IllustrationThree.vue?vue&type=script&lang=js"
export * from "./IllustrationThree.vue?vue&type=script&lang=js"

import "./IllustrationThree.vue?vue&type=style&index=0&id=472a5cd0&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472a5cd0"]])

export default __exports__